// Imports
import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic';
import { Essentials } from '@ckeditor/ckeditor5-essentials';
import { Autoformat } from '@ckeditor/ckeditor5-autoformat';
import { Bold, Italic, Underline } from '@ckeditor/ckeditor5-basic-styles';
import { BlockQuote } from '@ckeditor/ckeditor5-block-quote';
import { Heading } from '@ckeditor/ckeditor5-heading';
import { Image, ImageCaption, ImageStyle, ImageToolbar, ImageResize, ImageUpload } from '@ckeditor/ckeditor5-image';
import { Link, LinkImage } from '@ckeditor/ckeditor5-link';
import { LegacyList } from '@ckeditor/ckeditor5-list';
import { Paragraph } from '@ckeditor/ckeditor5-paragraph';
import { PasteFromOffice } from '@ckeditor/ckeditor5-paste-from-office';
import { TextTransformation } from '@ckeditor/ckeditor5-typing';
import { HorizontalLine } from '@ckeditor/ckeditor5-horizontal-line';
import { Indent } from '@ckeditor/ckeditor5-indent';
import { MediaEmbed } from '@ckeditor/ckeditor5-media-embed';
import { Table, TableToolbar, TableProperties, TableCellProperties } from '@ckeditor/ckeditor5-table';
import { SourceEditing } from '@ckeditor/ckeditor5-source-editing';
import { HtmlEmbed } from '@ckeditor/ckeditor5-html-embed';
import { Alignment } from '@ckeditor/ckeditor5-alignment';
import { FontSize, FontFamily, FontColor, FontBackgroundColor } from '@ckeditor/ckeditor5-font';
import CustomUpload from './plugins/custom-upload';
import Markdown from './plugins/markdown';
import RestrictTableCellContent from './plugins/restrict-table-cell-content';
import { GeneralHtmlSupport } from '@ckeditor/ckeditor5-html-support';
import './custom.css';
import NormalizeTableHeader from './plugins/normalize-table-header';
import AutolinkOnPaste from './plugins/autolink-on-paste';
import HTMLSnippetAutoSave from './plugins/html-snippet-auto-save';


// Editor build
export default class CKEditorBuild extends ClassicEditor {
	// Default plugins
	public static override builtinPlugins = [
		Essentials,
		Autoformat,
		Bold,
		Italic,
		Underline,
		BlockQuote,
		Heading,
		Image,
		ImageUpload,
		Link,
		LinkImage,
		LegacyList,
		Paragraph,
		PasteFromOffice,
		TextTransformation,
		HorizontalLine,
		CustomUpload,
		ImageCaption,
		ImageStyle,
		ImageToolbar,
		Indent,
		MediaEmbed,
		Table,
		TableToolbar,
		SourceEditing,
		HtmlEmbed,
		Alignment,
		FontSize,
		FontFamily,
		FontColor,
		FontBackgroundColor,
		ImageResize,
		TableProperties,
		TableCellProperties,
		Markdown,
		GeneralHtmlSupport,
		RestrictTableCellContent,
		NormalizeTableHeader,
		AutolinkOnPaste,
		HTMLSnippetAutoSave,
	];
}
